import { PILL_FALLBACK } from '../utils/purchaseStatus'

// Presentational only: the parent passes an already-translated `text`.
export default function StatusPill({ value, styleMap, text, placeholder = '—' }) {
  const cls = value ? (styleMap[value] || PILL_FALLBACK) : 'bg-transparent text-gray-400'
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {value ? text : placeholder}
    </span>
  )
}
